import { PageController } from '@client/components/_core/layout/PageController';
import { createFileRoute, Outlet } from '@tanstack/react-router';
import { FileEdit } from 'lucide-react';

export const Route = createFileRoute('/console/$orgId/configuration/claims-products/forms')({
    staticData: {
        metadata: {
            title: 'Forms',
        },
        modules: ['claim'],
        permissions: ['settings:update'],
        featureFlag: 'is-products-v2-enabled',
        ui: {
            icon: FileEdit,
            title: 'Forms',
            useTitleForChildren: true,
            menuDescription: 'Claim and attestation forms built in the designer and pinned to product versions',
        },
    },
    component: FormDesignerLayout,
});

function FormDesignerLayout() {
    return (
        <PageController route={Route}>
            <Outlet />
        </PageController>
    );
}
